module.exports = __webpack_public_path__ + "static/img/login_bg.2e1b3f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login_bg.png
// module id = rleu
// module chunks = 0